<div
  [style]="theme?.bgImage"
  [className]="theme?.root + ' mx-auto bg-no-repeat bg-center bg-cover'"
  >
  <div
    class="flex container {{ theme?.container }} mx-auto {{
      flexLayout
    }}" [ngClass]="{'items-center': useBannerLayout, '!px-v-spacing': theme?.container.length === 0 }">

    @if (hasImage) {
      <img
        [src]="data?.learnMoreImage[0].url"
        [alt]="data.learnMoreImage[0].altText"
        class="{{ useBannerLayout ? 'md:w-30p' : 'w-full' }} max-w-[200px] md:mr-12 mb-v-spacing md:mb-0 ml-v-spacing"
        />
    }
    <div class="flex {{ flexLayout }} {{ useBannerLayout ? 'md:w-70p items-center' : 'w-full' }}">
      <div
        class="w-full wysiwyg content-center {{ contentLayout }} {{ useBannerLayout && 'md:mr-8' }}"
        [innerHtml]="content"
      ></div>
      @if (data.ctaLink) {
        <div class="{{ buttonLayout }}">
          <div class="cta-container">
            <vision-button [data]="buttonData"></vision-button>
          </div>
        </div>
      }
    </div>
  </div>
</div>
